import * as React from 'react';

import SignFieldCheckBox16 from './SignFieldCheckBox16';

export const signFieldCheckBox16 = () => <SignFieldCheckBox16 />;

export default {
    title: 'Icon/Fill/SignFieldCheckBox16',
    component: SignFieldCheckBox16,
    parameters: {
        notes: "`import SignFieldCheckBox16 from 'box-ui-elements/es/icon/fill/SignFieldCheckBox16';`",
    },
};
